































































import "sweetalert2/src/sweetalert2.scss"
import Vue, { PropType } from 'vue'

import { Comentario, comentario_repository } from '../../../../store/livro-digital/comentarios-repository'
import { Livro } from '../../../../store/livro-digital/livros-repository'



export type Data = {
    loading: boolean
    comentarios: Comentario[]
}

export default Vue.extend({
    props: {
        livro: {
            type: Object as PropType<Livro>,
            required: true
        },
        codigo_condominio: {
            type: Number,
            required: true
        },
        reverse: {
            type: Boolean,
            default: false
        }
    },
    data(): Data {
        return {
            loading: false,
            comentarios: []
        }
    },
    methods: {
        close() {
            this.$emit('close')
        },
        toggleMenu() {
            this.$emit('toggleMenu')
        },
        prevPage() {
            
            this.$emit('prev')
        },
        selectDocument(comentario: Comentario) {
            this.$emit('selectDocument', comentario.IdDocumento)            
        },
        async loadComentarios() {
            try {
                this.loading = true
                const { ano: Ano, mes: Mes } = this.livro
                const CodCondominio = this.codigo_condominio

                this.comentarios = await comentario_repository.lista({
                    CodCondominio,
                    Ano,
                    Mes
                })
            } catch (err) {
                console.error(err)
            } finally {
                this.loading = false
            }
        },
        async print() {
            const comentarios = this.comentarios.map(comentario => {
                const data = comentario.Data.split('-').reverse().join('/')
                const lancamento = comentario.CodLancamento != 0 ? `- Lançamento ${comentario.CodLancamento}` : ''
                const texto = comentario.Texto.replace(/\n/igm,'<br />')
                return `
                    <p>${comentario.Nome} - ${data} - ${comentario.NomeDocumento} ${lancamento} - Considerações: <br /> ${texto}</p>
                `
            }).join('')
            const win = window.open('about:blank', '_new');
            win?.document.open();
            win?.document.write(`
                <html>
                    <head>
                        <style>
                            html, body {
                                margin: 0;
                                padding: 0;
                             
                            }
                        </style>    
                    </head>
                    <body onload="window.print()" onafterprint="window.close()">
                        ${comentarios}
                    </body>
                </html>
            `.trim())
            win?.document.close();
        }
    },
    watch: {
        livro: {
            immediate: true,
            deep: true,
            handler() {
                this.loadComentarios()
            }
        },
        codigo_condominio: {
            handler() {
                this.loadComentarios()
            }
        }
    }
})

